// QA runtime hooks for WORLD COSTA BLANCA.
//
// SOURCE REPO: Juanmaes83/Claude-of-Duty
// SOURCE PATH: tools/capture.mjs (harness side) — the `window.__READY__`
//   boot contract and named-shot pattern are adopted from that donor.
// METHOD: REPURPOSE (contract) — this file is the page-side half.
// WHY: deterministic, reproducible visual QA (MASTER PROMPT §16).

export function qaParams(search = location.search) {
  const params = new URLSearchParams(search);
  return {
    enabled: params.has('qa') || params.has('shot'),
    legacyView: params.get('qa'),
    shot: params.get('shot'),
    freeze: params.get('freeze') === '1',
    seed: params.get('seed'),
    reducedMotion: params.get('reduced-motion') === '1'
  };
}

let readyFrames = 0;
let readyDone = false;

/** Call once per rendered frame; flips window.__READY__ after the world has
 *  rendered a few stable frames (assets built, first paint settled). */
export function markFrameRendered() {
  if (readyDone) return;
  readyFrames += 1;
  if (readyFrames >= 5) {
    readyDone = true;
    window.__READY__ = true;
  }
}
